import { Flex, Typography } from 'antd';
import classes from './Option.module.scss';
import React from 'react';
import { COLORS } from 'shared/const/theme';
import { getLinearGradientString } from 'shared/libs/utils/helpers';
import { CardComponent } from 'shared/ui';
import { useSelector } from 'react-redux';
import { getCurrentEmi } from 'shared/config/store/selectors/app';
import { getAccounts } from 'shared/config/store/selectors/account';
import { getAccountCards } from 'shared/config/store/reducers/cardsSlice';

const { Text } = Typography;

type OptionProps = {
  onChange: (event: any, option: string) => unknown;
  option: string;
  id?: string;
}

const Option: React.FC<OptionProps> = ({ onChange, option, id }) => {
  const emi = useSelector(getCurrentEmi);
  const accountObject = useSelector(getAccounts)[option];

  // TODO: filter and check if card is active or other conditions
  const accountCards = useSelector(getAccountCards(emi, Number(option)));

  return(
  <Flex id={id} justify="space-between" align="center" className={classes['option']}
        onClick={(event) => onChange(event, option)}>
    <Flex vertical gap={4}>
      <Text  style={{ fontSize: 14 }}>
        {accountObject.iban}
      </Text>
      <Text style={{ fontSize: 18 }}>
        {(accountObject.available || 0).toFixed(2)} €
      </Text>
    </Flex>
    {accountCards.length !== 0 &&
      <CardComponent
        size="m"
        status={accountCards[0].status}
        shortNumber={accountCards[0].numberMasked.slice(-4)}
        bgColor={getLinearGradientString([COLORS.PRIMARY, COLORS.PRIMARY])}
      />
    }
  </Flex>
)};

export default Option;